module.exports = __webpack_public_path__ + "img/WINTER HAT PURPLE.d7386e2.svg";